module.exports = __webpack_public_path__ + "img/1.763a85d0.jpg";